import {AOperation} from "../models/operations/AOperation";
import {EOperationType} from "../models/utils/EOperationType";
import {InstallationElement} from "../models/operations/InstallationElement";
import {Geolocate} from "../models/operations/Geolocate";
import {InstallationEquipment} from "../models/operations/InstallationEquipment";
import {UninstallElement} from "../models/operations/UninstallElement";
import {ReplaceElement} from "../models/operations/ReplaceElement";
import {EEquipmentType} from "../models/utils/EEquipmentType";
import {GatewayStandAlone} from "../models/equipments/GatewayStandAlone";
import {Streetlight} from "../models/equipments/Streetlight";
import {AEquipment} from "../models/equipments/AEquipment";
import {EElementType} from "../models/utils/EElementType";
import {Mast} from "../models/elements/Mast";
import {Gateway} from "../models/elements/Gateway";
import {EnergyBox} from "../models/elements/EnergyBox";
import {SolarPanel} from "../models/elements/SolarPanel";
import {AElement} from "../models/elements/AElement";
import UninstallEquipment from "../models/operations/UninstallEquipment";

class RemapService {

    public remapObjectToOperation(object: any): AOperation | null {
        let operation: AOperation | null = null;
        if(object._type !== undefined) {
            switch (object._type) {
                case EOperationType.InstallationElement:
                    operation = InstallationElement.remapObjectToOperation(object);
                    break;
                case EOperationType.Geolocate:
                    operation = Geolocate.remapObjectToOperation(object);
                    break;
                case EOperationType.InstallationEquipment:
                    operation = InstallationEquipment.remapObjectToOperation(object);
                    break;
                case EOperationType.UninstallationElement:
                    operation = UninstallElement.remapObjectToOperation(object);
                    break;
                    case EOperationType.UninstallationEquipment:
                    operation = UninstallEquipment.remapObjectToOperation(object);
                    break;
                case EOperationType.ReplacementElement:
                    operation = ReplaceElement.remapObjectToOperation(object);
                    break;
                default:
                    // Nothing to do
                    break;
            }
        }
        return operation;
    }

    public remapObjectToEquipment(object: any): AEquipment | null {
        let equipment: AEquipment | null = null;
        if(object._type !== undefined) {
            switch (object._type) {
                case EEquipmentType.Gateway:
                    equipment = GatewayStandAlone.remapObjectToEquipment(object);
                    break;
                case EEquipmentType.Streetlight:
                    equipment = Streetlight.remapObjectToEquipment(object);
                    break;
                default:
                    // Nothing to do
                    break;
            }
        }
        return equipment;
    }

    public remapObjectToElement(object: any): AElement | null {
        let element: AElement | null = null;
        if(object._type !== undefined) {
            switch (object._type) {
                case EElementType.Mast:
                    element = Mast.remapObjectToElement(object);
                    break;
                case EElementType.Gateway:
                    element = Gateway.remapObjectToElement(object);
                    break;
                case EElementType.EnergyBox:
                    element = EnergyBox.remapObjectToElement(object);
                    break;
                case EElementType.SolarPanel:
                    element = SolarPanel.remapObjectToElement(object);
                    break;
                default:
                    // Nothing to do
                    break;
            }
        }
        return element;
    }

}

export default new RemapService();
